import { z } from 'zod';
import { messageReplySuggestionSchema } from '../../server/src/eventshub/schemas/message/message.suggestions';

import {
  communicationChannelEnum,
  MessageDirectionEnum,
  MessageStatusEnum,
} from '../enums';
import { attachmentUrlSchema } from './attachment-type';

export const messageAPISchema = z.object({
  id: z.string(),
  userId: z.string(),
  contactId: z.string(),
  content: z.string(),
  timestamp: z.number(),
  direction: MessageDirectionEnum,
  status: MessageStatusEnum,
  messageType: z.enum(['text', 'media', 'document', 'other']),
  attachments: attachmentUrlSchema,
  isReadByUser: z.boolean(),
  replySuggestions: messageReplySuggestionSchema.array(),
  channelType: communicationChannelEnum.default('sms'),
});

export type MessageAPI = z.infer<typeof messageAPISchema>;
